import React from 'react'
import ChiefComplaint from './items/ChiefComplaint';
import Problems from './items/Problems';
import Vitals from './items/Vitals';
import HPI from './items/HPI';
import ROS from './items/ROS';
import FollowUp from './items/FollowUp';
import AdditionalInfo from './items/AdditionalInfo';
import QualityOfCare from './items/QualityOfCare';
import ProcedureCodes from './items/ProcedureCodes';
import isNull from '../../../../../../../../../../utils/NullChecking';

const RenderGroupField = ({ item, setItem, activeAccordion, isGroupNote, ...props }) => {
  switch (!isNull(item.ItemID) && item.ItemID.split('-')[0]) {
    // Use the base ID to determine the type
    case 'ChiefComplaint':
      return <ChiefComplaint item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'Problems':
      return <Problems
        item={item}
        setItem={setItem}
        activeAccordion={activeAccordion}
        widgetUtilities={props?.widgetUtilities}
        itemCount={props?.itemCount}
        isGroupNote={isGroupNote}
      />;

    case 'Vitals':
      return <Vitals item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'HPI':
      return <HPI item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'ROS':
      return <ROS item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'FollowUp':
      return <FollowUp item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'AdditionalInfo':
      return <AdditionalInfo item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'QualityOfCare':
      return <QualityOfCare item={item} widgetUtilities={props?.widgetUtilities} itemCount={props?.itemCount} />;

    case 'ProcedureCodes':
      return <ProcedureCodes
        item={item}
        setItem={setItem}
        widgetUtilities={props?.widgetUtilities}
        itemCount={props?.itemCount}
        activeAccordion={activeAccordion}
        isGroupNote={isGroupNote}
      />;

    // case 'Checklist':
    // case 'CheckList':
    //   return <CheckList item={item} setItem={setItem} activeAccordion={activeAccordion} validations={props?.validations} itemCount={props?.itemCount} />;


    default:
      return null;
  }
}

export default RenderGroupField